<template>
  <div class="content">
    <div class="c_position">
      <span class="el-icon-location-outline"></span>
      <label>你现在的位置：</label>
      <label><span @click="routerNav()">首页</span>><span>下载中心</span>><span>{{pos}}</span></label>
    </div>
    <div class="profile">
      <div class="p_left">
        <div style="cursor:auto">下载中心</div>
        <div v-for="(item,index) in list"
          :key="index" @click="ptext(index)" :class="statuNum == 0 && selfnum==index?'change':'normal'">
          <label>{{item.label}}</label>
        </div>
      </div>
      <div class="p_right">
        <div class="p_type">{{pos}}</div>
        <div class="p_text">
          <div class="c_mes c_mes2">
            <ul>
              <li v-for="(item,index) in listChild" :key="index" style="position：relative">
                <el-tooltip class="item" :open-delay=300 effect="light" :content="item.title" placement="top-start" popper-class="testtooltip" offset = -400>
                  <span>{{item.title | dataShow}}</span>
                </el-tooltip>
                  <span class="s_text">(文件大小：{{item.fileSize}})</span>
                  <span class="t_text" @click="down(item.filePath)">下载</span>
                  <span class="c_date">{{item.createTime|dataFormat}}</span>
              </li>
            </ul>
          </div>
          <div class="block">
            <el-pagination
              background
              :current-page.sync="pageNum"
              @current-change="handleSizeChange"
              
              layout=" prev, pager, next, total, jumper"
              :total="total"
            ></el-pagination>
            <!-- @prev-click="pre" -->
              <!-- @next-click="nex" -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      limit:9,
      pageNum:1,
      total:0,
      statuNum: 0,
      selfnum: 0,
      poslist: ["入会申请表", "其他文件"],
      pos: "入会申请表",
      list:[],
      listChild:[]
    };
  },
  methods: {
    routerNav(){
      this.$router.push({ path: "/home" });
    },
    down(path){
      // console.log(path)
      // http://localhost:1235/filePortal/download/file.filePath?isRename=true
      window.open('api/tourist/download/'+path+'?isRename=true')
    },
    req(i) {
      //2
      // http://localhost:9966/api/article/findArticalList?columnId=f7ad8282b445420c9a15959bab408352&pageNum=1&limit=10&type=1
      this.$axios({
        method: "GET",
        url: "/tourist/findDownloadingCentreList",
        params: {
          columnId: this.list[i].value,
          pageNum: this.pageNum,
          limit: this.limit,
          fileType: "1",
        },
      }).then((respone) => {
        this.total = respone.data.data.total; //改 获取的总条数
        this.listChild = respone.data.data.list;
        // this.pageNum = 1;
      });


    },
    ptext(num) {
      // console.log(num)
      this.req(num);
      this.selfnum = num;
      this.pos = this.list[num].label;
      if (this.list[num].articalList != null) {
        this.listChild = this.list[num].articalList;
      } else {
        this.listChild = [];
      }
    },
    handleSizeChange(page){
        this.pageNum = page;
      this.req(this.selfnum);
    },
    // pre(){
    //         this.pageNum -= 1;
    //   this.req(this.selfnum);
    // },
    // nex(){
    //         this.pageNum += 1;
    //   this.req(this.selfnum);
    // },
  },
  mounted(){
    
    window['ptext'] = (num) => {
        this.ptext(num)
    }
     var id = window.sessionStorage.getItem("xzzx");
     this.$axios({
      method: "GET",
      url: "/tourist/findColumnByParentIdAndMenuId",
      params: {
        parentId: id,
        menuSign: 2,
      },
     }).then(res=>{
        // console.log(res.data,'------------sdas-----------------')
        this.list = res.data.data
        if (this.list !== []) {
          this.ptext(this.$route.query.num)
        }
        this.req(0)
        window.scrollBy(0, -1000)
     })

  },
  filters:{
    dataShow(msg) {
      if (msg.length >= 33) {
        var res = msg.slice(0, 33) + "...";
        return res;
      } else {
        return msg;
      }
    },
    dataFormat(msg) {
        try {
            var rs = msg.slice(0, 10);
            return rs;
        } catch (TypeError) {
          
        }
    }
  }
};
</script>
<style lang="less">
.el-tooltip__popper[x-placement^="top-start"] {
  // position: absolute !important;
  // top:-1000px !important;
  margin-bottom: 0px !important;
  padding:3px;
}

.el-tooltip__popper[x-placement^="top-start"] .popper__arrow {   
	border-style: none!important;
}
.el-tooltip__popper[x-placement^="top-start"] .popper__arrow:after {  
	border-style: none!important;
}
</style>
<style lang='less' scoped>
.c_position {
  margin-left: 50%;
  transform: translate(-200%);
}
.profile {
  width: 1173px;
  height: 824px;
  // margin-left: 353px;
  // margin:0 20%;
  margin-left: 50%;
  transform: translate(-50%);
  display: flex;
  flex-direction: row;
  margin-top: 7px;
  .p_left {
    width: 258px;
    height: 730px;
    border: 1px solid #f6f6f6;
    display: flex;
    flex-direction: column;
    background-color: #fdfdfd;
    div {
      width: 258px;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      label {
        margin-left: 24px;
        margin-top: 20px;
      }
      label:hover {
        cursor: pointer;
      }
    }
    div:hover {
      cursor: pointer;
      background-color: rgba(241, 244, 247, 1);
      color: rgba(19, 71, 121, 1);
    }
    div:nth-child(1) {
      color: white;
      text-align: center;
      font-size: 18px;
      font-weight: 1000;
      background-color: #1b7aca;
    }
    div:nth-child(1):hover {
      cursor: none;
      background-color: none;
    }
  }
  .p_right {
    height: 824px;
    width: 915px;
    .p_type {
      margin-left: 28px;
      height: 60px;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      color: rgba(49, 104, 155, 1);
      font-size: 18px;
      line-height: 65px;
      font-weight: 1000;
      padding-left: 20px;
    }
    .p_text {
      margin-top: 19px;
      height: 744px;
      width: 872px;
      margin-left: 48px;
      span:hover {
        color: #101010;
        cursor:auto;
        text-decoration:none;
      }
      .c_date {
        // margin-left:10px;
        margin-left: 10px;
        float: right;
        margin-right: 30px;
      }
    }
  }
  .c_mes2 {
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    width: 872px;
    height: 600px;
    border: none;
    ul {
      li {
        font-size: 16px;
        margin: 0px;
        border-bottom: 1px dashed #e9e9e9;
        height: 60px;
        padding: 0px;
        line-height: 60px;
      }
      li:hover{
        cursor: text;
        text-decoration: none;
      }
      .s_text{
        margin-left: 15px;
        color: rgb(175, 174, 174);
      }
      .t_text{
        margin-left: 2px;
        color: #3584CA ;
      }
      .t_text:hover{
        cursor:pointer;
        text-decoration: underline;
      }
      .c_date {
        float:right;
        color:#999ca1;;
      }
      .c_date:hover {
        color: #101010;
        cursor:auto;
        text-decoration:none;
      }
    }
  }
}
</style>